module.exports = __webpack_public_path__ + "static/warszawa-d9a9933e7d6c0eb949581d4ab3a5697e.png";